import { remoteCustomFetcher } from '@/providers/backendClient';
import { CustomPipelineFactory } from '@/providers/dataProvider';

export const conversionMonitorCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter, page, perPage, signal }) => {
    const result = await remoteCustomFetcher('conversionMonitor', {
      sort,
      filter,
      page,
      perPage,
      signal,
    });

    return result;
  };
